import { cn } from "@/lib/utils";

const GREEN = "text-emerald-600 border-emerald-200 bg-emerald-50";
const AMBER = "text-amber-600 border-amber-200 bg-amber-50";
const BLUE = "text-blue-600 border-blue-200 bg-blue-50";
const RED = "text-red-600 border-red-200 bg-red-50";
const PURPLE = "text-purple-600 border-purple-200 bg-purple-50";
const GREY = "text-slate-500 border-slate-200 bg-slate-100";

const STATUS_COLORS = {
  Paid: GREEN, "Fully Paid": GREEN, Verified: GREEN, Sent: GREEN, Draft: GREY, Queued: BLUE, Sending: BLUE, "Partially Paid": AMBER, "Under Verification": AMBER, "Pending Verification": AMBER, Subscribed: GREEN, Unsubscribed: GREY, "No Invoice": GREY, "Total Not Set": GREY, Unpaid: RED, Overpaid: PURPLE, Refunded: PURPLE, "Refunded / Adjusted": PURPLE, Reversed: GREY, "Not Collected": GREY,
  // green
  Converted: GREEN, Successful: GREEN, Received: GREEN, "Payment Received": GREEN,
  Achieved: GREEN, "On Track": BLUE, "At Risk": AMBER, "No Target": GREY, Synced: GREEN,
  Deployed: GREEN, "Replacement Deployed": GREEN, Resolved: GREEN, Active: GREEN,
  "Fully Verified": GREEN, Available: GREEN, Approved: GREEN, Completed: GREEN,
  "Remaining Payment Received": GREEN, Selected: GREEN, "Candidate Selected": GREEN,
  // amber
  "In Progress": AMBER, "Follow-Up": AMBER, "Not Responding": AMBER, Pending: AMBER, "Payment Pending": AMBER,
  Interested: AMBER, "Booking Confirmed": AMBER, Shortlisted: AMBER, "Verification Pending": AMBER,
  Escalated: AMBER, "Interview Scheduled": AMBER, "Profiles Shortlisted": AMBER, Overdue: AMBER,
  // blue
  New: BLUE, Contacted: BLUE, "Requirement Received": BLUE, Assigned: BLUE, "Booking Link Shared": BLUE,
  "Booking Form Submitted": BLUE, Generated: BLUE, Opened: BLUE, Submitted: BLUE,
  "Allocation Started": BLUE, "Profiles Shared": BLUE, "Aadhaar Verified": BLUE, "Police Verified": BLUE,
  // purple (replacement lifecycle)
  "Request Received": PURPLE, "Eligibility Under Review": PURPLE, "Replacement Requested": PURPLE,
  "Replacement Scheduled": PURPLE, "Profiles Under Review": PURPLE,
  // red
  Dropped: RED, "Not Interested": RED, Failed: RED, Cancelled: RED, Rejected: RED,
  Suspended: RED, Blacklisted: RED, Disputed: RED, Chargeback: RED,
  // grey
  Inactive: GREY, Closed: GREY, "Invalid Lead": GREY, "Duplicate Lead": GREY, "Not Verified": GREY,
};

export function StatusBadge({ status, className }) {
  if (!status) return <span className="text-muted-foreground text-xs">—</span>;
  const color = STATUS_COLORS[status] || "text-slate-600 border-slate-200 bg-slate-50";
  return (
    <span
      data-testid={`status-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
      className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-medium whitespace-nowrap", color, className)}
    >
      {status}
    </span>
  );
}
